import {
  BarChart3,
  Boxes,
  Settings,
  Shield,
  Terminal,
  Unplug
} from 'lucide-react';

export type MenuItem = {
  id: string; // same as link, used as React key
  name: string;
  icon: React.ReactElement;
  link: string;
};

type MenuOptions = {
  isPrivileged?: boolean;
  hasEnvVars?: boolean;
};

export const getStratumnProcessMenuItems = (
  options?: MenuOptions
): MenuItem[] => {
  const items: MenuItem[] = [
    {
      id: 'general',
      name: 'General',
      icon: <Settings size={20} />,
      link: 'general'
    },
    {
      id: 'database',
      name: 'Database',
      icon: <Settings size={20} />,
      link: 'database'
    },
    {
      id: 'generation',
      name: 'Generations',
      icon: <Unplug size={20} />,
      link: 'generation'
    }
  ];

  if (options?.hasEnvVars) {
    items.push({
      id: 'variables',
      name: 'Variables',
      icon: <Terminal size={20} />,
      link: 'variables'
    });
  }

  if (options?.isPrivileged) {
    items.push({
      id: 'admin',
      name: 'Admin',
      icon: <Shield size={20} />,
      link: 'admin'
    });
  }

  return items;
};

export const getDraftProcessMenuItems = (
  options?: MenuOptions & {
    isWorkspaceFeatureEnabled?: boolean;
  }
): MenuItem[] => {
  const items: MenuItem[] = [
    {
      id: 'general',
      name: 'General',
      icon: <Settings size={20} />,
      link: 'general'
    },
    {
      id: 'database',
      name: 'Database',
      icon: <Settings size={20} />,
      link: 'database'
    }
  ];

  if (options?.isWorkspaceFeatureEnabled) {
    items.push({
      id: 'workspaces',
      name: 'Workspaces',
      icon: <Boxes size={20} />,
      link: 'workspaces'
    });
  }

  items.push({
    id: 'generation',
    name: 'Generations',
    icon: <Unplug size={20} />,
    link: 'generation'
  });

  if (options?.hasEnvVars) {
    items.push({
      id: 'variables',
      name: 'Variables',
      icon: <Terminal size={20} />,
      link: 'variables'
    });
  }

  if (options?.isPrivileged) {
    items.push({
      id: 'admin',
      name: 'Admin',
      icon: <Shield size={20} />,
      link: 'admin'
    });
  }

  return items;
};

export const getWorkflowMenuItems = (options?: MenuOptions): MenuItem[] => {
  const items: MenuItem[] = [
    {
      id: 'editor',
      name: 'Editor',
      icon: <Settings size={20} />,
      link: 'editor'
    },
    // {
    //   id: 'trace-info',
    //   name: 'Notes',
    //   icon: <AppWindow size={20} />,
    //   link: 'trace-info'
    // },
    // {
    //   id: 'trace-overview',
    //   name: 'Overview',
    //   icon: <Grid3X3 size={20} />,
    //   link: 'trace-overview'
    // },
    // {
    //   id: 'global-variables',
    //   name: 'Variables',
    //   icon: <Variable size={20} />,
    //   link: 'global-variables'
    // },
    {
      id: 'analytics',
      name: 'Analytics',
      icon: <BarChart3 size={20} />,
      link: 'analytics'
    }
  ];

  if (options?.isPrivileged) {
    items.push({
      id: 'admin',
      name: 'Admin',
      icon: <Shield size={20} />,
      link: 'admin'
    });
  }

  return items;
};
